module.exports = __webpack_public_path__ + "img/two.87a17a8e.svg";